export default __webpack_public_path__ + "static/media/Girls_Skipping_Rope.35a2cd43.svg";